import { render, staticRenderFns } from "./CodingWizard.vue?vue&type=template&id=5f92cb4c&scoped=true&"
import script from "./CodingWizard.vue?vue&type=script&lang=js&"
export * from "./CodingWizard.vue?vue&type=script&lang=js&"
import style0 from "./CodingWizard.vue?vue&type=style&index=0&id=5f92cb4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f92cb4c",
  null
  
)

export default component.exports